module.exports = __webpack_public_path__ + "img/CuCipayung.fa41a296.png";